import { Checkbox, FormControlLabel, CheckboxProps } from '@mui/material';
import React from 'react';
import useTranslate from '../customHooks/useTranslate';

type CheckboxInputProps = CheckboxProps & {
    label?: React.ReactNode;
    labelText?: string;
    labelProps?: Omit<
        React.ComponentProps<typeof FormControlLabel>,
        'control' | 'label'
    >;
};

const CheckboxInput = ({
    label,
    labelText,
    labelProps,
    ...checkboxProps
}: CheckboxInputProps) => {
    const translatedLabel = labelText ? useTranslate(labelText) : undefined;
    const finalLabel = translatedLabel || label;
    const checkbox = <Checkbox {...checkboxProps} />;

    if (!finalLabel) {
        return checkbox;
    }

    return (
        <FormControlLabel
            control={checkbox}
            label={finalLabel}
            {...labelProps}
        />
    );
};

export default CheckboxInput;
